/* eslint-disable linebreak-style */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject } from '@angular/core';

import { CrudService } from '../../services/crud.service';
import { TableActionsBaseTemplate } from './table-actions-base.template';

@Component({
  template: ''
})
export class TableActionsTemplate extends TableActionsBaseTemplate {
  constructor(
    @Inject(String) private name: string,
    private service: CrudService
  ) {
    super();
  }
}
